import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TextContentService } from '@core/text-content/text-content.service';
import { FlightTrackerCopy } from '@dynamic-components/flight-tracker/types/flight-tracker-copy.type';
import { FlightTrackerLeg } from '@dynamic-components/flight-tracker/types/flight-tracker-leg.type';
import { memo } from '@shared/ui';
import { Observable } from 'rxjs';

import { FlightTrackerResultsService } from '../../flight-tracker-results.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'jb-flight-tracker-results-departure-column',
  templateUrl: './flight-tracker-results-departure-column.component.html',
  styleUrls: ['./flight-tracker-results-departure-column.component.scss'],
  providers: [FlightTrackerResultsService],
})
export class FlightTrackerResultsDepartureColumnComponent implements OnInit {
  leg;

  @Input('flightTrackerLeg') flightTrackerLeg: FlightTrackerLeg[];

  flightTrackerText$: Observable<FlightTrackerCopy>;
  private _destroy = inject(DestroyRef);

  constructor(
    private flightTrackerResultsService: FlightTrackerResultsService,
    private textContentService: TextContentService,
  ) {
    this.flightTrackerText$ = this.textContentService
      .getJsonAsset('flight-tracker')
      .pipe(takeUntilDestroyed(this._destroy));
  }

  ngOnInit() {
    this.leg = this.flightTrackerLeg;
  }

  @memo()
  convertTime(time: string) {
    return this.flightTrackerResultsService.convertTime(time);
  }
}
